// 登录注册
import login from '../language/login'
// 菜单
import router from '../language/router'
// 入网
import certification from '../language/certification'
// 多币种钱包
import wallet from '../language/wallet'
// 手续费管理
import feeManage from '../language/feeManage'
// 收结汇
import collSettle from '../language/collSettle'
// 结汇下发
import recepitDistribute from '../language/recepitDistribute'
// 用户设置
import setting from '../language/setting'
// 组件
import components from '../language/components'

export const language={
  login,
  router,
  certification,
  wallet,
  feeManage,
  collSettle,
  recepitDistribute,
  setting,
  components,
}

